/**
 * Estilos para o componente Button.
 *
 * Este módulo contém os componentes estilizados utilizados para renderizar
 * diferentes variações do botão na aplicação.
 *
 * @module Button.Styles
 */

import styled from '@emotion/styled';

/**
 * Componente base de botão estilizado.
 *
 * Define o estilo padrão para todos os botões da aplicação com:
 * - Padding interno
 * - Sem bordas (exceto uma borda inline transparente)
 * - Cantos arredondados
 * - Tamanho de fonte pequeno
 * - Cor de fundo azul (#3b86ff)
 * - Texto branco
 * - Sombra sutil
 * - Cursor pointer no hover
 *
 * @type {import('@emotion/styled').StyledComponent}
 */
export const StyledButton = styled.button`
  padding: 0.625rem;
  border: none;
  border-radius: 0.3125rem;
  font-size: 0.8rem;
  border-inline: 0.5px solid transparent;
  background-color: #3b86ff;
  color: #ffffff;
  box-shadow: -2px 1px 7px -5px rgba(0, 0, 0, 0.6);
  :hover {
    cursor: pointer;
  }
`;

/**
 * Extensão do botão estilizado com larguras variáveis.
 *
 * Estende o StyledButton e adiciona larguras diferentes baseadas na prop variant:
 * - 'lg': Botão largo (9.5em)
 * - outros valores: Botão padrão (5em)
 *
 * @type {import('@emotion/styled').StyledComponent}
 * @param {Object} props - Propriedades do componente
 * @param {string} props.variant - Variante do botão que determina sua largura
 */
export const ExtendedStyledButton = styled(StyledButton)`
  width: ${(props) => (props.variant === 'lg' ? '9.5em' : '5em')};
`;
